import Link from 'next/link';

import { ROUTES } from '@/config/routes';
import { cn } from '@/lib/cn';

/** Intrinsic size of public/images/nemo-launchpad-logo.* (trimmed to the wordmark). */
export const LOGO_WIDTH = 1000;
export const LOGO_HEIGHT = 124;
export const LOGO_ALT = 'NEMO LaunchPad';

/**
 * The NEMO LaunchPad wordmark. The original has white "NEMO" for dark surfaces;
 * `tone="light"` uses the copy with dark "NEMO" for white surfaces (the portal).
 * Height comes from `className`; width follows the aspect ratio.
 */
export function LogoImage({
  className,
  tone = 'dark',
}: {
  className?: string;
  /** The surface the logo sits on. */
  tone?: 'dark' | 'light';
}) {
  const file = tone === 'light' ? 'nemo-launchpad-logo-dark' : 'nemo-launchpad-logo';
  return (
    <picture className="flex min-w-0 shrink">
      <source type="image/avif" srcSet={`/images/${file}.avif`} />
      <source type="image/webp" srcSet={`/images/${file}.webp`} />
      <img
        src={`/images/${file}.png`}
        alt={LOGO_ALT}
        width={LOGO_WIDTH}
        height={LOGO_HEIGHT}
        decoding="async"
        className={cn('block w-auto max-w-full', className ?? 'h-6')}
      />
    </picture>
  );
}

export function Logo({ className }: { className?: string }) {
  return (
    <Link
      href={ROUTES.home}
      aria-label={`${LOGO_ALT} home`}
      className={cn('inline-flex min-w-0 shrink items-center', className)}
    >
      <LogoImage className="h-6 sm:h-8" />
    </Link>
  );
}
